const config = {
    firebaseConfig: {
        apiKey: "AIzaSyCOPBVwp2hZghLYUrmXtFiBzDhEyY3ciGU",
        authDomain: "labothecaire.firebaseapp.com",
        projectId: "labothecaire",
        storageBucket: "labothecaire.appspot.com",
        messagingSenderId: "412818457932",
        appId: "1:412818457932:web:5e5e9ffaaa2c4fdd63bbe9"
    }
}

if (typeof window !== "undefined") {
    window.bootstrapConfigSettings = config;
}
